import { twMerge } from 'tailwind-merge';
import { Button } from '../../../Button';

interface HeadingButtonProps {
  text: string;
  leftIcon?: React.ReactNode;
  disabled?: boolean;
  buttonClassName?: string;
  textClassName?: string;
  onClick: () => void;
}

export const HeadingButton = ({
  text,
  leftIcon,
  disabled,
  buttonClassName,
  textClassName,
  onClick,
}: HeadingButtonProps) => {
  return (
    <Button
      buttonClassName={twMerge(
        'bg-white h-[35px] border-1.5 border-gray-DCDFE8 dark-mode:bg-coal-500 dark-mode:border-gray-400',
        buttonClassName
      )}
      textClassName={twMerge(
        'text-light-inverse font-medium dark-mode:text-gray-600',
        textClassName
      )}
      text={text}
      leftIcon={leftIcon}
      disabled={disabled}
      onClick={onClick}
    />
  );
};
